import React, { useReducer } from "react";
export var Language;
(function (Language) {
    Language["SWEDISH"] = "sv";
    Language["ENGLISH"] = "en";
    Language["GERMAN"] = "de";
})(Language || (Language = {}));
export const LocalizationContext = React.createContext({});
export const withLocalization = (Component) => (props) => (React.createElement(LocalizationContext.Consumer, null, (contextProps) => React.createElement(Component, Object.assign({}, props, contextProps))));
function stateReducer(state, newState) {
    return Object.assign(Object.assign({}, state), newState);
}
export const LocalizationContextProvider = ({ children, }) => {
    const [state, setState] = useReducer(stateReducer, {
        language: Language.ENGLISH,
    });
    const getLocale = () => {
        let locale = state.language;
        if (state.country) {
            locale = `${state.language}-${state.country}`;
        }
        return locale;
    };
    return (React.createElement(LocalizationContext.Provider, { value: { state, setState, getLocale } }, children));
};
export function formatOnfidoMessage(formatMessage, messageDescriptor) {
    return formatMessage(messageDescriptor, {
        fallback: (str) => `<fallback>${str}</fallback>`,
        strong: (str) => `<strong>${str}</strong>`,
        country: "%{country}",
        number: "%{number}",
        side: "%{side}",
    });
}
